import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/tooltip/tooltip.component.js'

const tagName = 'dap-ds-tooltip'

/**
 * `dap-ds-tooltip`
 * @summary A tooltip is a container for tooltip content.
 * @element dap-ds-tooltip
 * @title - Tooltip
 *
 * @slot - The content of the tooltip.
 * @slot trigger - The trigger element of the tooltip.
 *
 * @csspart base - The main tooltip container.
 * @csspart trigger - The trigger element of the tooltip.
 * @csspart popup - The popup of the tooltip.
 * @csspart arrow - The arrow of the tooltip.
 *
 * @cssproperty --dds-tooltip-max-width - The maximum width of the tooltip before its content will wrap.
 * @cssproperty --dds-tooltip-padding - The padding inside the tooltip.
 * @cssproperty --dds-tooltip-border-color - The border color of the tooltip.
 * @cssproperty --dds-tooltip-bg-color - The background color of the tooltip.
 * @cssproperty --dds-tooltip-text-color - The text color of the tooltip.
 * @cssproperty --dds-tooltip-font-size - The font size of the tooltip text.
 * @cssproperty --dds-tooltip-box-shadow - The box shadow of the tooltip.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTooltip',
})

export default reactWrapper
